import React from "react";
import { Row, Col, Card, Button, Result, Divider, Layout, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

const styles = {
  row: {
    flexGrow: 1,
  },
};

export const RecuperacaoSenhaSucesso = () => {
  const navigate = useNavigate();

  return (
    <Row justify="center" align="middle" className="full-width" style={styles?.row}>
      <Col xs={23} sm={18} md={14} lg={12} xl={8} xxl={6}>
        <Card bordered={false}>
          <Result
            status="success"
            title="Senha alterada com sucesso!"
            subTitle="Sua senha foi redefinida com sucesso."
            extra={[
              <Button size="large" icon={<ArrowLeftOutlined />} onClick={() => window.close()} type="default">
                Voltar
              </Button>,
            ]}
          />

          <Divider />
          <Layout.Content style={{ textAlign: "center" }}>
            <Text disabled>DPTO TI - COPÉRDIA &copy;</Text>
          </Layout.Content>
        </Card>
      </Col>
    </Row>
  );
};
